<template>
  <PModal
    title="Confirmer la suppression du flux"
    :model-value="props.modelValue"
    @update:model-value="emit('update:modelValue', $event)"
    @open="onOpen"
  >
    <template #default>
      <div>
        <div class="mb-4">Voulez-vous vraiment vider le flux ?</div>

        <div>
          <PCheckbox v-model="addToCC" label="Ajouter les utilisateurs en copie" hide-messages />
          <div class="mt-2 italic">
            Les utilisateurs en copie pourront toujours consulter le parapheur et prendre la main.
          </div>
        </div>
      </div>
    </template>
    <template #actions="{ close }">
      <div class="flex gap-1 items-end justify-end">
        <PButton mode="secondary" @click="close">Annuler</PButton>
        <PButton mode="primary" @click="emit('emptyStream', addToCC)"> Vider le flux </PButton>
      </div>
    </template>
  </PModal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { PModal, PButton, PCheckbox } from "@pasta/box-v2";

interface Props {
  modelValue: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (event: "emptyStream", addToCC: boolean): void;
  (event: "update:modelValue", value: boolean): void;
}>();

const addToCC = ref(false);

function onOpen() {
  addToCC.value = true;
}
</script>
